"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useCollection;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _context = _interopRequireDefault(require("../context"));

var _getData = _interopRequireDefault(require("../helpers/getData"));

var defaultData = [];

function useCollection(props) {
  var path = props.path,
      query = props.query,
      _props$onlyIds = props.onlyIds,
      onlyIds = _props$onlyIds === void 0 ? false : _props$onlyIds,
      _props$flat = props.flat,
      flat = _props$flat === void 0 ? false : _props$flat,
      _props$track = props.track,
      track = _props$track === void 0 ? [] : _props$track;

  var _useContext = (0, _react.useContext)(_context["default"]),
      app = _useContext.app;

  var _useState = (0, _react.useState)(true),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      isLoading = _useState2[0],
      setIsLoading = _useState2[1];

  var _useState3 = (0, _react.useState)(defaultData),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      data = _useState4[0],
      setData = _useState4[1];

  (0, _react.useEffect)(function () {
    if (app) {
      var ref = app.firestore().collection(path);
      var finalQuery = query ? query(ref) : ref;
      var unsubscribe = finalQuery.onSnapshot(function (querySnapshot) {
        setData((0, _getData["default"])(querySnapshot.docs, onlyIds, flat));
        setIsLoading(false);
      }, function (err) {
        setIsLoading(false); // eslint-disable-next-line no-console

        console.log(err);
      });
      return function () {
        return unsubscribe();
      };
    }

    return null; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [app, path, onlyIds, flat].concat(track));
  return [data, isLoading];
}